<template>
    <div class="goodList">
        <Form
            ref="formValidate"
            :model="formValidate"
            :label-width="labelWidth"
            :label-position="labelPosition"
            class="tabform">
            <Row type="flex" :gutter="24">
                <Col v-bind="grid" v-if="!liveStatus">
                    <FormItem label="商品分类：" label-for="pid">
                        <Select
                                v-model="formValidate.store_category_id"
                                style="width: 200px"
                                clearable
                                @on-change="userSearchs">
                            <Option v-for="item in treeSelect" :value="item.id" :key="item.id">{{
                                item.name }}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col v-bind="grid">
                    <FormItem label="商品搜索：" label-for="name">
                        <Input
                                search
                                enter-button
                                placeholder="请输入商品名称,关键字,编号"
                                v-model="formValidate.name"
                                style="width: 240px"
                                @on-search="userSearchs"/>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <Table
                ref="table"
                no-data-text="暂无数据"
                @on-selection-change="changeCheckbox"
                no-filtered-data-text="暂无筛选结果"
                max-height="400"
                :columns="liveStatus == false ? columns4 : columns5"
                :data="tableList"
                :loading="loading">
            <template slot-scope="{ row, index }" slot="image">
                <viewer>
                    <div class="tabBox_img">
                        <img v-lazy="row.product_pic_main"/>
                    </div>
                </viewer>
            </template>
            <template slot-scope="{ row, index }" slot="name">
                <div>
                    <span>{{row.name}} [{{row.sku_name}}]</span>
                </div>
            </template>
            <template slot-scope="{ row, index }" slot="category">
                <div>{{row.category ? row.category.name : ''}}</div>
            </template>
        </Table>
        <div class="acea-row row-right page">
            <Page
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                    :page-size="formValidate.pagesize"/>
        </div>
        <div class="footer" slot="footer" v-if="many === 'many' && !diy">
            <Button
                    type="primary"
                    size="large"
                    :loading="modal_loading"
                    long
                    @click="ok">提交
            </Button>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "index",
        props: {
            in_store: {
                type: Number,
                default: 0,
            },
            diy: {
                type: Boolean,
                default: false,
            },
            isdiy: {
                type: Boolean,
                default: false,
            },
            ischeckbox: {
                type: Boolean,
                default: false,
            },
            liveStatus: {
                type: Boolean,
                default: false,
            },
            datas: {
                type: Object,
                default: function () {
                    return {};
                },
            },
        },
        data() {
            return {
                modal_loading: false,
                treeSelect: [],
                formValidate: {
                    page: 1,
                    pagesize: 15,
                    store_category_id: "",
                    name: "",
                },
                total: 0,
                modals: false,
                loading: false,
                grid: {
                    xl: 10,
                    lg: 10,
                    md: 12,
                    sm: 24,
                    xs: 24,
                },
                tableList: [],
                currentid: 0,
                goodsRow: {},
                columns4: [
                    {
                        title: "商品ID",
                        key: "goods_id",
                    },
                    {
                        title: "图片",
                        slot: "image",
                    },
                    {
                        title: "商品名称",
                        slot: "name",
                        minWidth: 250,
                    },
                    {
                        title: "商品分类",
                        slot: "category",
                        minWidth: 100,
                    },
                ],
                columns5: [
                    {
                        title: "商品ID",
                        key: "goods_id",
                    },
                    {
                        title: "图片",
                        slot: "image",
                    },
                    {
                        title: "商品名称",
                        key: "name",
                        minWidth: 250,
                    },
                ],
                images: [],
                diyVal: [],
                many: "",
            };
        },
        computed: {
            labelWidth() {
                return 120;
            },
            labelPosition() {
                return "right";
            },
        },
        created() {
            let radio = {
                width: 60,
                align: "center",
                render: (h, params) => {
                    let goods_id = params.row.goods_id;
                    let unique = params.row.unique;
                    let flag = false;
                    if (this.currentid === goods_id && this.currentunique === unique) {
                        flag = true;
                    } else {
                        flag = false;
                    }
                    let self = this;
                    return h("div", [
                        h("Radio", {
                            props: {
                                value: flag,
                            },
                            on: {
                                "on-change": () => {
                                    self.currentid = goods_id;
                                    self.currentunique = unique
                                    this.goodsRow = params.row;
                                    this.$emit("getProductId", this.goodsRow);
                                    if (this.goodsRow.goods_id) {
                                        if (this.$route.query.fodder === "image") {
                                            /* eslint-disable */
                                            let imageObject = {
                                                goods_image: this.goodsRow.goods_image,
                                                goods_id: this.goodsRow.goods_id,
                                                unique: this.goodsRow.unique,
                                                name: this.goodsRow.name,
                                            };
                                            form_create_helper.set("image", imageObject);
                                            form_create_helper.close("image");
                                        }
                                    } else {
                                        this.$Message.warning("请先选择商品");
                                    }
                                },
                            },
                        }),
                    ]);
                },
            };

            let checkbox = {
                type: "selection",
                width: 60,
                align: "center",
            };
            let many = "";
            if (this.ischeckbox) {
                many = "many";
            } else {
                many = this.$route.query.type;
            }
            this.many = many;
            if (many === "many") {
                this.columns4.unshift(checkbox);
                this.columns5.unshift(checkbox);
            } else {
                this.columns4.unshift(radio);
                this.columns5.unshift(radio);
            }
        },
        mounted() {
            this.goodsCategory();
            this.getList();
        },
        methods: {
            changeCheckbox(selection) {
                let images = [];
                selection.forEach(function (item) {
                    let imageObject = {
                        image: item.image,
                        product_id: item.id,
                        name: item.name,
                        unique: item.unique,
                        temp_id: item.temp_id
                    };
                    images.push(imageObject);
                });
                this.images = images;
                this.diyVal = selection;
                this.$emit("getProductDiy", selection);
            },
            // 商品分类；
            goodsCategory() {
                this.axios.post('store/category/tree', {})
                .then((res) => {
                    this.treeSelect = res.data.list;
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
            },
            pageChange(index) {
                this.formValidate.page = index;
                this.getList();
            },
            // 列表
            getList() {
                this.loading = true;
                this.formValidate.in_store = this.in_store
                this.axios.post('store/goods/skuList', this.formValidate)
                .then(async (res) => {
                    if (res.code == 1) {
                        let data = res.data.list;
                        this.tableList = data.data;
                        this.total = data.total;
                        this.loading = false;
                    }
                })
                .catch((res) => {
                    this.loading = false;
                    this.$Message.error(res.msg);
                });
            },
            ok() {
                if (this.images.length > 0) {
                    if (this.$route.query.fodder === "image") {
                    } else {
                        if (this.isdiy) {
                            this.$emit("getProductId", this.diyVal);
                        } else {
                            this.$emit("getProductId", this.images);
                        }
                    }
                } else {
                    this.$Message.warning("请先选择商品");
                }
            },
            // 表格搜索
            userSearchs() {
                this.formValidate.page = 1;
                this.getList();
            },
            clear() {
                this.goodsRow.id = "";
                this.currentid = "";
            },
        },
    };
</script>

<style scoped lang="less">
    .footer {
        margin: 15px 0;
    }

    .tabBox_img {
        width: 36px;
        height: 36px;
        border-radius: 4px;
        cursor: pointer;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .tabform {
        .ivu-form-item {
            margin-bottom: 16px !important;
        }
    }
    .btn {
        margin-top: 20px;
        float: right;
    }
    .goodList {
        table {
            width: 100% !important;
        }
    }
</style>
